import LeasesHeaderNav from '../components/LeasesHeaderNav';
import { ErrorPage } from '@zg-rentals/error-page-components';
import { getErrorPageAction } from '../utils/getErrorPageTextProps';

export default function LeasesNotFound() {
  return (
    <LeasesHeaderNav>
      <ErrorPage errorMessage="Page not found" action={getErrorPageAction()} />
    </LeasesHeaderNav>
  );
}
